/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MongoFileChunk from './MongoFileChunk';

/**
 * The FilePrepareResponseModel model module.
 * @module model/FilePrepareResponseModel
 * @version v1.0.0
 */
class FilePrepareResponseModel {
    /**
     * Constructs a new <code>FilePrepareResponseModel</code>.
     * @alias module:model/FilePrepareResponseModel
     */
    constructor() { 
        
        FilePrepareResponseModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FilePrepareResponseModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FilePrepareResponseModel} obj Optional instance to populate.
     * @return {module:model/FilePrepareResponseModel} The populated <code>FilePrepareResponseModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FilePrepareResponseModel();

            if (data.hasOwnProperty('fileId')) {
                obj['fileId'] = ApiClient.convertToType(data['fileId'], 'String');
            }
            if (data.hasOwnProperty('fileName')) {
                obj['fileName'] = ApiClient.convertToType(data['fileName'], 'String');
            }
            if (data.hasOwnProperty('fileType')) {
                obj['fileType'] = ApiClient.convertToType(data['fileType'], 'String');
            }
            if (data.hasOwnProperty('md5')) {
                obj['md5'] = ApiClient.convertToType(data['md5'], 'String');
            }
            if (data.hasOwnProperty('uploaded')) {
                obj['uploaded'] = ApiClient.convertToType(data['uploaded'], 'Boolean');
            }
            if (data.hasOwnProperty('uploadedChunkList')) {
                obj['uploadedChunkList'] = ApiClient.convertToType(data['uploadedChunkList'], [MongoFileChunk]);
            }
            if (data.hasOwnProperty('url')) {
                obj['url'] = ApiClient.convertToType(data['url'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} fileId
 */
FilePrepareResponseModel.prototype['fileId'] = undefined;

/**
 * @member {String} fileName
 */
FilePrepareResponseModel.prototype['fileName'] = undefined;

/**
 * @member {String} fileType
 */
FilePrepareResponseModel.prototype['fileType'] = undefined;

/**
 * @member {String} md5
 */
FilePrepareResponseModel.prototype['md5'] = undefined;

/**
 * @member {Boolean} uploaded
 */
FilePrepareResponseModel.prototype['uploaded'] = undefined;

/**
 * @member {Array.<module:model/MongoFileChunk>} uploadedChunkList
 */
FilePrepareResponseModel.prototype['uploadedChunkList'] = undefined;

/**
 * @member {String} url
 */
FilePrepareResponseModel.prototype['url'] = undefined;






export default FilePrepareResponseModel;

